import { useEffect, useState } from 'react';

export function useStopwatch(startTs: number) {
  const [digits, setDigits] = useState(['0', '0', '0', '0']);

  useEffect(() => {
    const interval = setInterval(() => {
      const now = Date.now();
      const diff = now - startTs;

      const minutes = Math.floor(diff / 60000);
      const seconds = Math.floor((diff % 60000) / 1000);

      const arr = ['0', '0', ':', '0', '0'];

      arr[0] = Math.floor(minutes / 10).toString();
      arr[1] = (minutes % 10).toString();
      arr[3] = Math.floor(seconds / 10).toString();
      arr[4] = (seconds % 10).toString();

      setDigits(arr);
    }, 100);

    return () => clearInterval(interval);
  });

  return digits;
}
